/**
 * Created by yangxiaoshuo on 2018/11/30.
 */
import Vue from 'vue'
export const EventBus = new Vue()



// WEBPACK FOOTER //
// ./src/util/event-bus.js